/*************************************
 *
 * 特卖会
 *
 *************************************/
const storeSale = [
  {
    path: '/storeSale/storeList',
    name: 'storeSaleList',
    component: () => import('@/views/storeSale/storeSaleList/storeSaleList'),
    mate: {
      title: '门店特卖会',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/storeSale/articleList',
    name: 'storeArticleList',
    component: () => import('@/views/storeSale/saleList/saleList'),
    mate: {
      title: '浦江仓特卖会',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/storeSale/detail',
    name: 'storeArticleDetail',
    component: () => import('@/views/storeSale/saleDetail/index'),
    mate: {
      title: '浦江仓特卖会',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  }
]
export default storeSale



// WEBPACK FOOTER //
// ./src/router/modules/storeSale.js